const { createAction } = require("../../helpers");
const {
  GET_PRODUCTS_LIST_WITH_FILTERS,
  GET_PRODUCTS_LIST_WITH_FILTERS_SUCCESS,
  GET_PRODUCTS_LIST_WITH_FILTERS_ERROR,
  GET_PRODUCTS_LIST_WITH_FILTERS_RESET,

  GET_PRODUCTS_LIST_WITHOUT_FILTERS,
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_SUCCESS,
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_ERROR,
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_RESET,

  GET_PRODUCTS_LIST_WITH_SEARCH,
  GET_PRODUCTS_LIST_WITH_SEARCH_SUCCESS,
  GET_PRODUCTS_LIST_WITH_SEARCH_ERROR,
  GET_PRODUCTS_LIST_WITH_SEARCH_RESET,

  GET_NEW_PRODUCT,
  GET_NEW_PRODUCT_SUCCESS,
  GET_NEW_PRODUCT_ERROR,
  GET_NEW_PRODUCT_RESET,

  GET_FEATURED_PRODUCT,
  GET_FEATURED_PRODUCT_SUCCESS,
  GET_FEATURED_PRODUCT_ERROR,
  GET_FEATURED_PRODUCT_RESET,

  GET_PARTICULAR_PRODUCTS,
  GET_PARTICULAR_PRODUCTS_SUCCESS,
  GET_PARTICULAR_PRODUCTS_ERROR,
  GET_PARTICULAR_PRODUCTS_RESET,

  GET_STORE_DETAILS,
  GET_STORE_DETAILS_SUCCESS,
  GET_STORE_DETAILS_ERROR,
  GET_STORE_DETAILS_RESET,

  GET_STORE_PRODUCT_LIST,
  GET_STORE_PRODUCT_LIST_SUCCESS,
  GET_STORE_PRODUCT_LIST_ERROR,
  GET_STORE_PRODUCT_LIST_RESET,

  GET_STORE_FEATURED_PRODUCT_LIST,
  GET_STORE_FEATURED_PRODUCT_LIST_SUCCESS,
  GET_STORE_FEATURED_PRODUCT_LIST_ERROR,
  GET_STORE_FEATURED_PRODUCT_LIST_RESET,

  GET_PRODUCT_CATEGORY,
  GET_PRODUCT_CATEGORY_SUCCESS,
  GET_PRODUCT_CATEGORY_ERROR,
  GET_PRODUCT_CATEGORY_RESET,
} = require("./constants");

const getProductCategory = ({ name, size, pageSize,search }) =>
  createAction(GET_PRODUCT_CATEGORY, { name, size, pageSize,search });

const getProductCategorySuccess = (data) =>
  createAction(GET_PRODUCT_CATEGORY_SUCCESS, { data });

const getProductCategoryError = (error) =>
  createAction(GET_PRODUCT_CATEGORY_ERROR, { error });

const getProductCategoryReset = () => createAction(GET_PRODUCT_CATEGORY_RESET);

const getProductsListWithFilters = ({ page, pageSize, search, filters }) =>
  createAction(GET_PRODUCTS_LIST_WITH_FILTERS, {
    page,
    pageSize,
    search,
    filters,
  });

const getProductsListWithFiltersSuccess = (data) =>
  createAction(GET_PRODUCTS_LIST_WITH_FILTERS_SUCCESS, { data });

const getProductsListWithFiltersError = (error) =>
  createAction(GET_PRODUCTS_LIST_WITH_FILTERS_ERROR, { error });

const getProductsListWithFiltersReset = () =>
  createAction(GET_PRODUCTS_LIST_WITH_FILTERS_RESET);

const getProductsListWithoutFilters = ({ page, pageSize, search }) =>
  createAction(GET_PRODUCTS_LIST_WITHOUT_FILTERS, { page, pageSize, search });

const getProductsListWithoutFiltersSuccess = (data) =>
  createAction(GET_PRODUCTS_LIST_WITHOUT_FILTERS_SUCCESS, { data });

const getProductsListWithoutFiltersError = (error) =>
  createAction(GET_PRODUCTS_LIST_WITHOUT_FILTERS_ERROR, { error });

const getProductsListWithoutFiltersReset = () =>
  createAction(GET_PRODUCTS_LIST_WITHOUT_FILTERS_RESET);

const getProductsListWithSearch = ({ page, pageSize, search }) =>
  createAction(GET_PRODUCTS_LIST_WITH_SEARCH, { page, pageSize, search });

const getProductsListWithSearchSuccess = (data) =>
  createAction(GET_PRODUCTS_LIST_WITH_SEARCH_SUCCESS, { data });

const getProductsListWithSearchError = (error) =>
  createAction(GET_PRODUCTS_LIST_WITH_SEARCH_ERROR, { error });

const getProductsListWithSearchReset = () =>
  createAction(GET_PRODUCTS_LIST_WITH_SEARCH_RESET);

const getNewProducts = (type) => createAction(GET_NEW_PRODUCT, { type });

const getNewProductsSuccess = (data) =>
  createAction(GET_NEW_PRODUCT_SUCCESS, { data });

const getNewProductsError = (error) =>
  createAction(GET_NEW_PRODUCT_ERROR, { error });

const getNewProductsReset = () => createAction(GET_NEW_PRODUCT_RESET);

const getFeaturedProducts = (type) =>
  createAction(GET_FEATURED_PRODUCT, { type });

const getFeaturedProductsSuccess = (data) =>
  createAction(GET_FEATURED_PRODUCT_SUCCESS, { data });

const getFeaturedProductsError = (error) =>
  createAction(GET_FEATURED_PRODUCT_ERROR, { error });

const getFeaturedProductsReset = () => createAction(GET_FEATURED_PRODUCT_RESET);

const getParticularProducts = (uuid) =>
  createAction(GET_PARTICULAR_PRODUCTS, { uuid });

const getParticularProductsSuccess = (data) =>
  createAction(GET_PARTICULAR_PRODUCTS_SUCCESS, { data });

const getParticularProductsError = (error) =>
  createAction(GET_PARTICULAR_PRODUCTS_ERROR, { error });

const getParticularProductsReset = () =>
  createAction(GET_PARTICULAR_PRODUCTS_RESET);
const getStoreDetails = () => createAction(GET_STORE_DETAILS);

const getStoreDetailsSuccess = (data) =>
  createAction(GET_STORE_DETAILS_SUCCESS, { data });

const getStoreDetailsError = (error) =>
  createAction(GET_STORE_DETAILS_ERROR, { error });

const getStoreDetailsReset = () => createAction(GET_STORE_DETAILS_RESET);

const getStoreProducts = ({ page, pageSize, search, type, uuid }) =>
  createAction(GET_STORE_PRODUCT_LIST, {
    page,
    pageSize,
    search,
    type,
    uuid,
  });

const getStoreProductsSuccess = (data) =>
  createAction(GET_STORE_PRODUCT_LIST_SUCCESS, { data });

const getStoreProductsError = (error) =>
  createAction(GET_STORE_PRODUCT_LIST_ERROR, { error });

const getStoreProductsReset = () => createAction(GET_STORE_PRODUCT_LIST_RESET);

const getStoreFeaturedProducts = ({ page, pageSize, search, type, uuid }) =>
  createAction(GET_STORE_FEATURED_PRODUCT_LIST, {
    page,
    pageSize,
    search,
    type,
    uuid,
  });

const getStoreFeaturedProductsSuccess = (data) =>
  createAction(GET_STORE_FEATURED_PRODUCT_LIST_SUCCESS, { data });

const getStoreFeaturedProductsError = (error) =>
  createAction(GET_STORE_FEATURED_PRODUCT_LIST_ERROR, { error });

const getStoreFeaturedProductsReset = () =>
  createAction(GET_STORE_FEATURED_PRODUCT_LIST_RESET);

module.exports = {
  getProductsListWithFilters,
  getProductsListWithFiltersSuccess,
  getProductsListWithFiltersError,
  getProductsListWithFiltersReset,

  getProductsListWithoutFilters,
  getProductsListWithoutFiltersSuccess,
  getProductsListWithoutFiltersError,
  getProductsListWithoutFiltersReset,

  getProductsListWithSearch,
  getProductsListWithSearchSuccess,
  getProductsListWithSearchError,
  getProductsListWithSearchReset,

  getNewProducts,
  getNewProductsSuccess,
  getNewProductsError,
  getNewProductsReset,

  getFeaturedProducts,
  getFeaturedProductsSuccess,
  getFeaturedProductsError,
  getFeaturedProductsReset,

  getParticularProducts,
  getParticularProductsSuccess,
  getParticularProductsError,
  getParticularProductsReset,

  getStoreDetails,
  getStoreDetailsSuccess,
  getStoreDetailsError,
  getStoreDetailsReset,

  getStoreProducts,
  getStoreProductsSuccess,
  getStoreProductsError,
  getStoreProductsReset,

  getStoreFeaturedProducts,
  getStoreFeaturedProductsSuccess,
  getStoreFeaturedProductsError,
  getStoreFeaturedProductsReset,

  getProductCategory,
  getProductCategorySuccess,
  getProductCategoryError,
  getProductCategoryReset,
};
